import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import {addSuccessMessage} from "../SnackBar";

export const COMPETITIONS_MAKE_DRAW_REQUEST = 'COMPETITIONS_MAKE_DRAW_REQUEST';
export const COMPETITIONS_MAKE_DRAW_FAILURE = 'COMPETITIONS_MAKE_DRAW_FAILURE';
export const COMPETITIONS_MAKE_DRAW_SUCCESS = 'COMPETITIONS_MAKE_DRAW_SUCCESS';

export const makeCategoryDraw = (data) => {
    return function(dispatch) {
        dispatch(request());
        return axios(apiRequestOptions(apiPath.COMPETITION_RESULT.DRAW, data))
            .then(transformHttpResponse)
            .then(response => {
                // The COMPETITION travels with the result. Caches keyed on it
                // — the category list's fight counts and estimates — cannot
                // invalidate what they cannot identify, and `response.data` is
                // the draw's rows, not the competition.
                dispatch(success(response.data, data.competition))
                dispatch(addSuccessMessage('Draw successfully created'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(failure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const request = () => ({type: COMPETITIONS_MAKE_DRAW_REQUEST});

const failure = error => ({type: COMPETITIONS_MAKE_DRAW_FAILURE, error,});

const success = (result, competition) => ({type: COMPETITIONS_MAKE_DRAW_SUCCESS, result, competition,});
